import type { ContractingFilters, SearchProfile } from "@/types/domain";

/** Map a stored SearchProfile into the ContractingFilters used by the hooks. */
export function profileToFilters(profile: SearchProfile): ContractingFilters {
  return {
    searchProfileId: profile.searchprofile_id,
    search: profile.searchprofile_search ?? undefined,
    onlyInterests: profile.searchprofile_onlyinterests ?? undefined,
    departmentId: profile.searchprofile_departmentids ?? undefined,
    provinceId: profile.searchprofile_provinceids ?? undefined,
    districtId: profile.searchprofile_districtids ?? undefined,
    procuringEntityId: profile.searchprofile_procuringentityids ?? undefined,
    dateFrom: profile.searchprofile_date_from ?? undefined,
    dateTo: profile.searchprofile_date_to ?? undefined,
    stage: profile.searchprofile_stages ?? undefined,
    subject: profile.searchprofile_subjects ?? undefined,
    keywords: profile.searchprofile_keywords ?? undefined,
    contratadomaxdays: profile.searchprofile_contratadomaxdays ?? undefined,
    amountMin: profile.searchprofile_amountmin ?? undefined,
    amountMax: profile.searchprofile_amountmax ?? undefined,
    scope: profile.searchprofile_scope ?? undefined,
  };
}
